module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_5-18fad901c4635d2880d1165721489b47.webp";